export enum tripTypesEnum {
  Round = 'roundTripForm',
  OneWay = 'oneWayForm',
  MultiCity = 'multiCityForm'
}
